import React, { Fragment, Component } from 'react';
import ChalanFormView from '../HelperChunks/ChalanFormView';
import LoginMenu from '../../../../components/LoginMenu/LoginMenu';
import CircularProgress from '@material-ui/core/CircularProgress';
import ReactToPrint from 'react-to-print';
import { Button } from '@material-ui/core';
import PrintIcon from '@material-ui/icons/Print';

class TutionFeeChalanForm extends Component {

    constructor(props) {
        super(props);
        this.state = {
            chalanData: {},
            isLoginMenu: false,
            isReload: false,
            isLoading: false
        }
    }

    componentDidMount() {
        this.getData();
    }

    getData = async () => {
        this.setState({
            isLoading: true
        })
        let url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/common/C13FinanceStudentsLegacyFeePendingVoucherView`;
        await fetch(url, {
            method: "GET",
            headers: new Headers({
                Authorization: "Bearer " + localStorage.getItem("uclToken"),
            }),
        })
            .then((res) => {
                if (!res.ok) {
                    throw res;
                }
                return res.json();
            })
            .then(
                (json) => {
                    if (json.CODE === 1) {
                        if (json.DATA) {
                            if (json.DATA.length > 0) {
                                this.setState({
                                    chalanData: json.DATA[0] || {}
                                });
                            }
                        }
                    } else {
                        alert(json.SYSTEM_MESSAGE + "\n" + json.USER_MESSAGE);
                    }
                })
            .catch((error) => {
                if (error.status == 401) {
                    this.setState({
                        isLoginMenu: true,
                        isReload: true
                    })
                } else {
                    alert('Operation Failed, Please try again later.');
                }
                console.log(error);
            });
        this.setState({
            isLoading: false
        })
    }

    render() {
        return (
            <Fragment>
                <ReactToPrint
                    trigger={() => {
                        return <Button style={{
                            float: 'right',
                            marginTop: 10,
                            marginRight: 20,
                            textTransform: 'capitalize',
                            opacity: 0.8
                        }} color="primary" variant="contained">
                            <PrintIcon style={{ paddingRight: 5 }} /> Print
                            </Button>;
                    }
                    }
                    content={() => this.componentRef}
                    pageStyle="@page { size: landscape; margin: 0mm;}"
                />
                <LoginMenu reload={this.state.isReload} open={this.state.isLoginMenu} handleClose={() => this.setState({ isLoginMenu: false })} />
                {
                    this.state.isLoading ? <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        marginTop: '20%',
                        alignItems: 'center'
                    }}> <CircularProgress size={35} /> <span style={{ marginTop: 10 }}>Please Wait...</span> </div> :
                        <div ref={el => (this.componentRef = el)} style={{
                            display: 'flex',
                            justifyContent: 'space-around',
                            fontFamily: 'inherit',
                            marginTop: 50
                        }}>
                            <ChalanFormView data={this.state.chalanData} feeCard="School Copy" />
                            <ChalanFormView data={this.state.chalanData} feeCard="Bank Copy" />
                            <ChalanFormView data={this.state.chalanData} feeCard="Parent Copy" />
                        </div>
                }
            </Fragment >
        );
    }
}

export default TutionFeeChalanForm;